module.exports = __webpack_public_path__ + "static/media/16a-03_ST-2016-2032x3175mm-oleo-sobre-madera.29747f89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/16a/16a-03_ST-2016-2032x3175mm-oleo-sobre-madera.jpg
// module id = 185
// module chunks = 0